// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__jiYy0","content":"style_content__3tXa7","fullScreenOnMobile":"style_fullScreenOnMobile__2qilm"};